import { Pipe, PipeTransform } from '@angular/core';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { ScoreService } from '../../match-tracker/tracker-board/services/score.service';
import { PartnerConnectService } from '../../_core/services/partner-connect.service';
import { Match } from '../models/match.model';

interface Args {
    setIndex: number;
    sideNumber: number;
}

@Pipe({
    name: 'gameScore',
    pure: false,
    standalone: false
})

export class GameScorePipe implements PipeTransform {

    constructor(
        private bhs: BoardHelpService,
        private pcs: PartnerConnectService,
        private scoreService: ScoreService
    ) { }

    transform(match: Match, ...args: Args[]): string {
        if (match) {
            // console.log(args);

            return this.getGameScore(match, args[0].setIndex, args[0].sideNumber);
        } else {
            return '0';
        }
    }

    getGameScore(match: Match, setIndex: number, sideNumber: number) {
        if (match.sets?.length || match.score?.sets?.length) {
            const gameScore = match.score?.sets?.length
                ? sideNumber === 1
                    ? match.score.sets[setIndex]?.side1Score || '0'
                    : match.score.sets[setIndex]?.side2Score || '0'
                : this.bhs.getGameScore(match.sets[setIndex], sideNumber);

            const response = this.scoreService.isMatchCompletedAndLastSetTiebreak(match, setIndex)
                ? `[${this.getTiebreakScore(match, setIndex, sideNumber)}]`
                : String(gameScore);

            return response;

        } else {
            return '0';
        }
    }

    getTiebreakScore(match: Match, setIndex: number, sideNumber: number) {
        return match.score?.sets?.length
            ? sideNumber === 1
                ? match.score.sets[setIndex].side1TiebreakScore
                : match.score.sets[setIndex].side2TiebreakScore
            : this.pcs.getTiebreakScore(match.sets[setIndex], sideNumber);
    }

}
